var exports = {
  "k": "xa15a2ab7--cc9d66--container",
};

module.exports = exports;
